import React from 'react';

import { MockAccountOwner } from '../data/MockAccountOwner';
import { MockClient } from '../data/MockClient';

const UserContext = React.createContext({
  client: MockClient,
  user: MockAccountOwner,
  selectedAccounts: MockAccountOwner.accounts,
});

export default UserContext;
